import React, { useEffect, useRef } from "react";
import CloseIcon from '@mui/icons-material/Close';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import { useState } from "react";

const Video = ({ videoId,showVideo, onClose }) => {


  const handleClockIconClick = () => {
    
    onClose(); // Đóng video
  };



  
  return (
    <>
         {showVideo && (
          <>
            <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black opacity-90" style={{ zIndex: 1000 }}></div>
                <div className="fixed  top-0 left-0 w-full h-full  " style={{zIndex: 999999}}>
                  <div className="flex bg-black opacity-95 justify-between w-full max-w-screen-lg px-4 py-2">
                    <div id="lg-counter" className="text-[#999] text-lg">
                      <span id="lg-counter-current">1</span> / <span id="lg-counter-all">1</span>
                    </div>
                    <div className="flex gap-4">
                      <ZoomOutIcon className="text-[#999] cursor-pointer opacity-50 text-xl" />
                      <ZoomInIcon className="text-[#999]  cursor-pointer text-xl" />
                      <CloseIcon className="text-[#999] cursor-pointer  text-xl" onClick={handleClockIconClick}/>
                    </div>
                  </div>
                  <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" >
                  <iframe
                    title="YouTube Video"
                    className="lg-video-object lg-object"
                    width="560"
                    height="315"
                    src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
 
          </div>
          </>) };
      
         
    </>
   
  );
};

export default Video;
